import { ChainId } from '@pancakeswap/sdk'
import { ComputedFarmConfigV3 } from '../../src/types'
import { farmsV3 as farm1 } from '../1'
import { farmsV3 as farm5 } from '../5'
import { farmsV3 as farm56 } from '../56'
import { farmsV3 as farm97 } from '../97'
import { farmsV3 as farm167012 } from '../167012'
import { farmsV3 as farm19416 } from '../19416'
import { farmsV3 as farm202555 } from '../202555'

export const farmsV3ConfigChainMap: Record<ChainId, ComputedFarmConfigV3[]> = {
  [ChainId.ETHEREUM]: farm1,
  [ChainId.GOERLI]: farm5,
  [ChainId.BSC]: farm56,
  [ChainId.BSC_TESTNET]: farm97,
  [ChainId.KASPLEX_TESTNET]: farm167012,
  [ChainId.IGRA]: farm19416,
  [ChainId.KASPLEX_MAINNET]: farm202555,
}
